import type { SVGProps } from 'react';

export function CookieIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.056 3.435a.465.465 0 0 0-.386-.397 3.97 3.97 0 0 0-2.415.427L6.48 4.946a3.98 3.98 0 0 0-1.703 1.767L3.401 9.548a3.98 3.98 0 0 0-.341 2.433l.544 3.105a3.98 3.98 0 0 0 1.151 2.172l2.261 2.19c.604.585 1.373.96 2.201 1.076l3.113.439a3.97 3.97 0 0 0 2.415-.428l2.775-1.481a3.97 3.97 0 0 0 1.703-1.77l1.376-2.831a3.98 3.98 0 0 0 .341-2.434.47.47 0 0 0-.398-.379 4.81 4.81 0 0 1-3.918-3.652.72.72 0 0 0-.589-.548 4.81 4.81 0 0 1-3.982-4.005zM10.2 7.8c.664 0 1.2.536 1.2 1.2s-.536 1.2-1.2 1.2S9 9.664 9 9s.536-1.2 1.2-1.2M7.8 15c0-.664.536-1.2 1.2-1.2s1.2.536 1.2 1.2-.536 1.2-1.2 1.2-1.2-.536-1.2-1.2m8.4-2.4c.664 0 1.2.536 1.2 1.2a1.199 1.199 0 1 1-2.4 0c0-.664.536-1.2 1.2-1.2" />
    </svg>
  );
}
